import * as ACTION_TYPES from "../actions/action_types";

export const initialState = {
  callbacks: "NoCustomer",
};

export const CallbacksReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.SET_CALLBACKS:
      return {
        ...state,
        callbacks: action.payload,
      };
    case ACTION_TYPES.FAILURE:
      return {
        ...state,
        callbacks: "FAILURE",
      };
    default:
      return state;
  }
};
